<template>
  <b-modal
    ref="preGeracao"
    size="xl"
    hide-footer
    no-close-on-backdrop
    :dialog-class="'alteracao-tamanho'"
    :modal-class="'center-modal'"
    title="Pré - geração do contrato comercial"
    title-class="titulo-modal"
    @show="showPreGeracao"
    @hide="limparCampos"
  >
    <validation-observer ref="validacao">
      <div class="aviso">
        Agora falta pouco para gerar o contrato comercial, adicione os dados abaixo e envie para nossos analistas!
      </div>
      <transferencia-matriz-filial
        v-if="valueInner.tipoProposta === 'transferencia'"
        ref="transferencia"
        v-model="preGeracao"
        :filial="valueInner.filial"
        :tipo-proposta="valueInner.tipoProposta"
        :desabilitar-campos="preGeracao.enviadoParaAnalise"
        @closeInCancel="closeModal"
      />

      <constituicao-matriz
        v-else-if="valueInner.tipoProposta === 'constituicao'"
        ref="constituicao"
        v-model="preGeracao"
        :filial="valueInner.filial"
        :tipo-proposta="valueInner.tipoProposta"
        @closeInCancel="closeModal"
      />

      <div class="mb-4">
        <div class="mb-2 border p-1">
          <p>
            <strong>Atenção:</strong> Os documentos abaixo são essenciais para a proposta. Caso não possua todos em mãos neste momento, você poderá realizar o envio posteriormente.
          </p>
        </div>
        <documentos-proposta-section :proposta-id="propostaAtual.propostaIdVinculada" />
      </div>

    </validation-observer>
    <b-row class="mt-2">
      <b-col>
        <div style="display: flex;justify-content: flex-end;">
          <b-btn
            variant="primary"
            size="sm"
            class="mr-1"
            :disabled="preGeracao.enviadoParaAnalise"
            @click="salvar"
          >
            Salvar
          </b-btn>
          <b-btn
            variant="warning"
            size="sm"
            class="mr-1"
            :disabled="preGeracao.enviadoParaAnalise"
            @click="enviar"
          >
            Enviar para análise
          </b-btn>
          <b-btn
            variant="danger"
            size="sm"
            @click="cancelar"
          >
            Cancelar
          </b-btn>
        </div>
      </b-col>
    </b-row>
    <loading
      :is-loading="isLoading"
      :cancelar-upload="cancelarBusca"
    />
  </b-modal>
</template>

<style lang="scss">
.alteracao-tamanho {
  width: 1000px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}

.titulo-modal {
  font-size: 19px;
}

.aviso {
  text-align: left;
  font-size: 15.5px;
  background-color: rgb(231, 231, 231) !important;
  padding: 0.5rem;
  margin-bottom: 1rem;
  color: rgb(255, 0, 0);
  font-weight: bold;
  p{
    margin:0
  }
}
</style>

<script>
import { generateCode } from '@core/utils/utils'
import { ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'

export default {
  name: 'PreGeracaoContrato',
  components: {
    ValidationObserver,
    TransferenciaMatrizFilial: () => import('./components/shared/transferencia-matriz-e-filial/TransferenciaMatrizEFilial.vue'),
    ConstituicaoMatriz: () => import('./components/shared/constituicao-matriz/ConstituicaoMatriz.vue'),
    Loading: () => import('@/shared/components/loading/Loading.vue'),
    DocumentosPropostaSection: () => import('../documentos-proposta/DocumentosPropostaSection.vue'),
  },
  props: {
    propostaAtual: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      preGeracao: {
        eTipoFaturamentoBoletos: null,
        emailsBoletosNFs: [],
        enviadoParaAnalise: false,
        realizadoBusca: true,
        carregado: false,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          nome: null,
          funcao: null,
          veioDoRFB: false,
          tipoInscricao: 'cpf',
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
          semCertificado: false,
        },
      },
      valueInner: {},
    }
  },
  watch: {
    propostaAtual(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.showPreGeracao()
      }
    },
  },
  created() {
    this.valueInner = { ...this.propostaAtual }
  },
  methods: {
    showPreGeracao() {
      // eslint-disable-next-line global-require
      const axios = require('axios')
      if ((this.valueInner.status === 'aprovada' || this.valueInner.status === 'aguardandoassinatura') && this.valueInner.id > 0 && this.valueInner.tipoProposta === 'transferencia') {
        api.getPreGeracaoContrato(this.valueInner.id)
          .then(result => {
            if (result.data && result.data.realizadoBusca) {
              this.preGeracao = result.data
              this.preGeracao.carregado = true

              if (!this.preGeracao.socios || this.preGeracao.socios.length === 0) {
                this.adicionarSocio()
              }
            } else {
              this.preGeracao.realizadoBusca = false
              const itemChecklist = this.valueInner.itemChecklistPropostas.find(find => find.tipoRegra === 'tags')
              api.getEmpresasPreGeracao(itemChecklist.listaRespostas, axios.CancelToken)
                .then(payload => {
                  const dados = payload.data
                  this.preGeracao.empresas = dados.empresas
                  if (!this.valueInner.filial) {
                    this.preGeracao.socios = dados.socios
                  }
                  if (!this.preGeracao.socios || this.preGeracao.socios.length === 0) {
                    this.adicionarSocio()
                  }
                  this.preGeracao.carregado = true
                  this.preGeracao.realizadoBusca = true
                })
            }
            this.preGeracao.eTipoFaturamentoBoletos = (!result.data || result.data.eTipoFaturamentoBoletos === 0) ? null : result.data.eTipoFaturamentoBoletos
          })
      } else if ((this.valueInner.status === 'aprovada' || this.valueInner.status === 'aguardandoassinatura') && this.valueInner.id > 0 && this.valueInner.tipoProposta === 'constituicao') {
        api.getPreGeracaoContrato(this.valueInner.id)
          .then(result => {
            if (result.data) {
              this.preGeracao = result.data
              this.preGeracao.carregado = true

              if (!result.data.socios || result.data.socios.length === 0) {
                this.adicionarSocio()
              }
            } else {
              // eslint-disable-next-line no-lonely-if
              if (!this.preGeracao.socios || this.preGeracao.socios.length === 0) {
                this.adicionarSocio()
              }
              this.preGeracao.carregado = true
            }
          })
      }
    },
    hasEmailDuplicado(array) {
      const valuesSoFar = Object.create(null)
      const arr = array.filter(fil => fil.email && fil.email !== '')
      for (let i = 0; i < arr.length; i += 1) {
        const value = arr[i].email
        if (value in valuesSoFar) {
          return true
        }
        valuesSoFar[value] = true
      }
      return false
    },
    enviar() {
      if (this.preGeracao.carregado) {
        this.$refs.validacao.validate()
          .then(success => {
            if (success) {
              const dados = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
              const senhaIncorreta = dados && dados.anexosECertificado && dados.anexosECertificado.senhaIncorreta
              if (!dados.socios || dados.socios.length === 0 || (dados.socios.length === 1 && dados.socios.some(som => !som.nome || som.nome === ''))) {
                this.$erro('Deve ter no mínimo um sócio adicionado!')
              } else if (!dados.socios.some(some => some.responsavelRFB)) {
                this.$erro('Informe qual sócio é responsável perante a RFB para enviar os dados para análise!')
              } else if (!dados.anexosECertificado.semCertificado && (!dados.anexosECertificado.tipoCertificado || dados.anexosECertificado.tipoCertificado === '0')) {
                this.$erro('Selecione um tipo de certificado!')
              } else if (!dados.anexosECertificado.semCertificado && dados.anexosECertificado.tipoCertificado.toLowerCase() === 'a1' && (!dados.anexosECertificado.nomeArquivoCertificado || dados.anexosECertificado.nomeArquivoCertificado === '')) {
                this.$erro('Certificado é obrigatório!')
              } else if (!dados.anexosECertificado.semCertificado && dados.anexosECertificado.tipoCertificado.toLowerCase() === 'a1' && (!dados.anexosECertificado.senhaCertificado || dados.anexosECertificado.senhaCertificado === '')) {
                this.$erro('Preencha a senha')
              } else if ((this.valueInner.tipoProposta === 'transferencia' || (this.valueInner.tipoProposta === 'constituicao' && this.valueInner.filial))
                && (!dados.anexosECertificado.nomeArquivoContratual || dados.anexosECertificado.nomeArquivoContratual === '')) {
                this.$erro('Arquivo contratual é obrigatório!')
              } else if (dados.anexosECertificado.anexoVencido) {
                this.$erro('Não é permitido anexar certificado vencido!')
              } else if (senhaIncorreta) {
                this.$erro('Informe a senha correta do certificado')
              } else if (this.hasEmailDuplicado(dados.socios)) {
                this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
              } else if (!dados.emailsBoletosNFs || dados.emailsBoletosNFs.length === 0) {
                this.$erro('Informe o e-mail para recebimento de boletos e NFs!')
              } else {
                this.$confirmar('Deseja realmente enviar os dados para análise agora?', 'Os sócios serão notificados por e-mail assim que o contrato estiver disponível!', 'question', 'danger')
                  .then(result => {
                    if (result.value) {
                      this.isLoading = true
                      const formData = this.getFormDataBody(dados)
                      api.salvarEEnviarPreGeracao(this.valueInner.id, formData, this.valueInner.tipoProposta === 'constituicao')
                        .then(() => {
                          api.notificaPropostaPendenteDeAnalise(this.valueInner.propostaIdVinculada)
                            .then(() => {
                              this.isLoading = false
                              this.$sucesso('Enviado os dados!')
                              this.fecharPreGeracaoEnviada()
                            })
                            .catch(err => {
                              this.isLoading = false
                              this.$sucesso('Enviado os dados!')
                              this.fecharPreGeracaoEnviada()
                              throw err
                            })
                        })
                        .catch(err => {
                          this.isLoading = false
                          this.$erro(err.response.data.message || err.message)
                          throw err
                        })
                    }
                  })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Preencha os campos corretamente',
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            this.$erro('Preencha os campos corretamente!')
            throw err
          })
      }
    },
    salvar() {
      if (this.preGeracao.carregado) {
        this.isLoading = true
        const dados = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
        if (!dados.socios || dados.socios.some(socios => socios.nome === '' || !socios.nome)) {
          this.isLoading = false
          this.$erro('É obrigatório informar o nome dos sócios')
        } else if (!dados.socios || dados.socios.some(socios => socios.inscricao === '' || !socios.inscricao)) {
          this.isLoading = false
          this.$erro('É obrigatório informar a inscrição federal dos sócios')
        } else if (dados.anexosECertificado && dados.anexosECertificado.senhaIncorreta) {
          this.isLoading = false
          this.$erro('Informe a senha correta do certificado')
        } else if (dados.anexosECertificado && dados.anexosECertificado.anexoVencido) {
          this.isLoading = false
          this.$erro('Não é permitido anexar certificado vencido!')
        } else if (this.hasEmailDuplicado(dados.socios)) {
          this.isLoading = false
          this.$erro('Existem sócios com e-mail duplicado! Verifique a informação.')
        } else {
          const value = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia.valueInner : this.$refs.constituicao.valueInner
          const formData = this.getFormDataBody(value)
          api.salvarPreGeracao(this.valueInner.id, formData, this.valueInner.tipoProposta === 'constituicao')
            .then(() => {
              this.$sucesso('Dados salvos!')
              this.cancelar()
            })
            .catch(err => {
              this.$erro(err.response.data.message || err.message)
              throw err
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      }
    },
    cancelarBusca() {
      this.isLoading = false
      api.cancelarBusca()
    },
    cancelar() {
      this.$refs.preGeracao.hide()
      this.$emit('fechado')
    },
    fecharPreGeracaoEnviada() {
      this.$emit('enviado')
      this.$refs.preGeracao.hide()
    },
    adicionarSocio() {
      this.preGeracao.socios = [{
        nome: null,
        cpf: null,
        veioDoRFB: false,
        tipoInscricao: 'cpf',
        telefoneContato: {
          telefone: null,
          telefoneWhatsApp: false,
          celular: null,
          celularWhatsApp: false,
        },
        code: generateCode(),
      }]
    },
    limparCampos() {
      this.valueInner = null
      this.preGeracao = {
        emailsBoletosNFs: [],
        realizadoBusca: true,
        carregado: false,
        empresas: [{
          inscricao: null,
          nomeEmpresarial: null,
          matrizFilial: null,
        }],
        socios: [{
          nome: null,
          funcao: null,
          tipoInscricao: 'cpf',
          veioDoRFB: false,
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
        }],
        anexosECertificado: {
          certificadoSelecionado: false,
          contratualSelecionado: false,
          outrosSelecionado: false,
          certificado: [],
          senhaCertificado: null,
          tipoCertificado: null,
          dataVencimentoCertificado: null,
          certificadoFisico: null,
          nomeArquivoContratual: null,
          nomeArquivoOutrosAnexos: null,
          nomeArquivoCertificado: null,
          semCertificado: false,
        },
      }
      this.$emit('fechado')
    },
    getFormDataBody(body) {
      const formData = new window.FormData()
      const ref = this.valueInner.tipoProposta === 'transferencia' ? this.$refs.transferencia : this.$refs.constituicao
      const arquivo = this.valueInner.tipoProposta === 'transferencia' ? ref.$refs.anexos.getArquivosAnexados() : ref.$refs.anexos.getArquivosAnexados()
      const fileCertificado = arquivo.certificado
      const fileContratual = arquivo.contratual
      const fileOutros = arquivo.outros
      if (fileCertificado) {
        const name = `certificado;${fileCertificado.filename || fileCertificado.name}`
        formData.append('files', fileCertificado.file, name)
      }
      if (fileContratual) {
        const name = `contratual;${fileContratual.filename || fileContratual.name}`
        formData.append('files', fileContratual.file, name)
      }
      if (fileOutros) {
        const name = `outros;${fileOutros.filename || fileOutros.name}`
        formData.append('files', fileOutros.file, name)
      }

      const arquivosSocio = ref.retornaTodosArquivos()
      for (let index = 0; index < arquivosSocio.length; index += 1) {
        const { file, nome } = arquivosSocio[index]
        formData.append('files', file, nome)
      }

      formData.append('body', JSON.stringify(body))

      return formData
    },
    closeModal() {
      this.$refs.preGeracao.hide()
    },
  },
}
</script>
